import * as React from 'react';

import { isAppApproaching } from './is-app-approaching';

const IOS_APP = 'IOS app';
const ANDROID_APP = 'ANDROID app';
const IOS_WEB = 'IOS web';
const ANDROID_WEB = 'ANDROID web';
const PC_WEB = 'PC web';

export const IOS_USER_AGENT_PATTERN = /iPhone|iPod|iPad/i;
export const ANDROID_USER_AGENT_PATTERN =
  /Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i;
export const ANDROID_BRAND_PATTERN = /LG|SAMSUNG|Samsung/;

export const getDeviceByUserAgent = (): Device | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const userAgent = navigator.userAgent;

  if (isAppApproaching({ isIOSApproaching: true })) {
    return IOS_APP;
  }

  if (isAppApproaching({ isAndroidpproaching: true })) {
    return ANDROID_APP;
  }

  if (userAgent.match(IOS_USER_AGENT_PATTERN) != null) {
    return IOS_WEB;
  }

  if (
    userAgent.match(ANDROID_USER_AGENT_PATTERN) != null ||
    userAgent.match(ANDROID_BRAND_PATTERN) != null
  ) {
    return ANDROID_WEB;
  }

  return PC_WEB;
};

export const useGetUserDevice = () => {
  const [device, setDevice] = React.useState<Device | undefined>(undefined);

  React.useEffect(() => {
    setDevice(getDeviceByUserAgent());
  }, []);

  return device;
};
